import React from 'react'
import { useSelector } from 'react-redux'

const ListofConsumable = () => {
  const { allConsumables } = useSelector(({ property }) => property)

  return (
    <>
      {/* {allConsumables?.map((consumables, index) => (
        <div className="accordion_sec_title" key={index}>
          {consumables?.task}
        </div>
      ))} */}

      <ol className="common_order_list_div">
        {allConsumables?.map((consumables, index) => (
          <li key={index}> {consumables?.task}</li>
        ))}
      </ol>
    </>
  )
}

export default ListofConsumable
